import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import { Box, Skeleton, Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { limitToSeven } from '../../utils/url-id';
import { headerSty, contentSty } from '../table-styles';
import { FeedBackData } from '../../interface/employment';

interface FeedBackTable {
  data: any[];
  loading: boolean;
  handleModal: () => void;
  setSelectedData: React.Dispatch<React.SetStateAction<FeedBackData>>;
}

export default function EmployeeFeedbackTable({
  data,
  loading,
  handleModal,
  setSelectedData,
}: FeedBackTable) {
  const theme = useTheme();
  const headStyles = { ...headerSty, color: theme.palette.neutral.main };
  const contentStyles = { ...contentSty };

  const navigate = useNavigate();
  const [openRow, setOpenRow] = React.useState<number | null>(null); // Track which row is open

  const handleToggleOpen = (rowId: number) => {
    setOpenRow((prevOpenRow) => (prevOpenRow === rowId ? null : rowId));
  };

  const handleRowClick = (data: FeedBackData) => {
    setSelectedData(data);
    handleModal();
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        background: theme.palette.common.white,
        boxShadow: 'none',
        minHeight: 300,
      }}
    >
      <Table
        sx={{
          minWidth: 650,
          boxShadow: 'none',
          my: 2,
          paddingRight: 2,
        }}
        aria-label="simple table"
      >
        <TableHead sx={{ paddingX: 2 }}>
          <TableRow>
            <TableCell sx={{ ...headStyles, width: '12%' }}>
              Employee ID
            </TableCell>
            <TableCell sx={{ ...headStyles }}>Name</TableCell>
            <TableCell sx={{ ...headStyles }}>Medic Type</TableCell>
            <TableCell sx={{ ...headStyles }}>Rating</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading &&
            data.map((row: FeedBackData, index: number) => (
              <TableRow
                onClick={() => handleRowClick(row)}
                key={row?._id}
                // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell sx={contentStyles}>
                  {limitToSeven(row?._id)}
                </TableCell>
                <TableCell sx={{ ...contentStyles }}>
                  {row?.medic_info?.name}
                </TableCell>
                <TableCell sx={{ ...contentStyles }}>
                  {row?.medic_info?.medic_type}
                </TableCell>

                <TableCell sx={{ ...contentStyles }}>
                  {row?.performance_rating ?? '-'}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {data?.length === 0 && !loading && (
        <Box
          sx={{
            height: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, color: theme.palette.neutral.main }}
          >
            No Appraisal.
          </Typography>
        </Box>
      )}
      {loading && (
        <Box sx={{ width: '96%', mx: 'auto' }}>
          <Skeleton
            variant="rounded"
            width={'100%'}
            height={30}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={'100%'}
            height={30}
            sx={{ my: 2 }}
          />
          <Skeleton
            variant="rounded"
            width={'100%'}
            height={30}
            sx={{ my: 2 }}
          />
        </Box>
      )}
    </TableContainer>
  );
}
